import * as yup from "yup";

export const FLEET_VEHICLE_MILEAGE_FORM_SCHEMA = (currentMileage: number | null) =>
    yup.object().shape({
        kmTraveled: yup
            .number()
            .required("Molimo Vas da unesete kilometražu")
            .min(currentMileage ?? 0, `Kilometraža ne može biti manja od trenutne (${currentMileage ?? 0} km)`)
            .typeError("Molimo Vas da unesete valjanu vrijednost"),
    });